export default function NoFunds() {
    return (
        <>
            <div className=" mx-2 border-2 border-dashed border-green-1 rounded-md items-center text-center p-8 mt-4">
                <p className=" text-green-1">شما عضو صندوقی نیستید</p>
            </div>
        </>
    )
}
